<template>
    <ul class="friends">
        <Friend v-for="friend in friends"
                :key="friend.friendId"
                :friend="friend"
                @forgotten="forgotten" />
    </ul>
</template>
<script>
import Friend from '@/app/pages/friends/Friend';

export default {
    components: { Friend },

    props: {
        friends: {
            type: Array,
            required: true,
        },
    },

    methods: {
        forgotten(friend) {
            const index = this.friends.findIndex((f) => f.friendId === friend.friendId);
            console.log(index);
            if (index !== -1) {
                // eslint-disable-next-line vue/no-mutating-props
                this.friends = this.friends.splice(index, 1);
            }
        },
    },
};
</script>
